import domain from './domain';

// Reset authentication form
export const resetAuthenticationFormStep = domain.createEvent('resetAuthenticationFormStep');

// Reset email schema
export const resetEmailSchema = domain.createEvent('resetEmailSchema');
